import Vue from "vue";
import Router from "vue-router";
import ErrorPage from "../components/ErrorPage";
import LoginErrorPage from "../components/LoginErrorPage";
import HomePage from "../components/homepage/HomePage";
import PageNotFound from "../components/PageNotFound";
import Forbidden from "../components/Forbidden";
import ContentPage from "../components/ContentPage";
import SearchPage from "../components/search/SearchPage";
import ProfilePage from "../components/profile/ProfilePage";
import GuidedHelpPage from "../components/guided-help/GuidedHelpPage";

import ServiceDirectory from "../components/service-directory/ServiceDirectory";
import EnterpriseServiceDirectory from "../components/enterprise-service-directory/EnterpriseServiceDirectory";
import EnterpriseServiceDirectoryPlatform from "../components/enterprise-service-directory/EnterpriseServiceDirectoryPlatform";
import BrowseArticle from "../components/knowledge-article/BrowseArticle";
import BrowseService from "../components/service-browser/BrowseService";
import KnowledgeArticle from "../components/knowledge-article/KnowledgeArticle";

import ContactSupport from "../components/contact-support/ContactSupportPage";

// pages
import NewsFeedPage from "@/components/homebase/NewsFeedPage";
import AutodeskOneBookmarksPage from "@/components/homebase/pages/AutodeskOneBookmarksPage";
import EventsPage from "@/components/homebase/pages/EventsPage";

import * as CONSTANTS from "@/store/constants";


Vue.use(Router);

const convertPlatformCategoryToUppercase = (to, from, next) => {
  if (to.params.platformCategory) {
    to.params.platformCategory = to.params.platformCategory.toUpperCase();
  }
  next();
};

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    // Prevent scroll to top when news summary modal opens
    if (to.path === CONSTANTS.NEWS_SUMMARY_PATH || from.path === CONSTANTS.NEWS_SUMMARY_PATH) return;

    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: "history",
  routes: [
    {
      path: "/home",
      name: "home",
      alias: "/",
      component: HomePage,
      meta: {
        title: "Home - Autodesk One",
        displayHeader: true,
        hideSearch: true,
        showITAndHR: true
        // Analytics not provided, handled by core-components
      }
    },
    {
      path: "/cn",
      redirect: "landing"
    },
    {
      path: "/page-not-found",
      name: "page-not-found",
      component: PageNotFound,
      meta: {
        displayHeader: true,
        analytics: "Error - Page not found"
      }
    },
    {
      path: "/forbidden",
      name: "Forbidden",
      component: Forbidden,
      meta: {
        analytics: "Error - Forbidden",
        displayHeader: true
      }
    },
    {
      path: "/error",
      name: "error",
      component: ErrorPage,
      meta: {
        displayHeader: false,
        analytics: "Error - Something has gone wrong"
      }
    },
    {
      path: "/login-error",
      name: "login-error",
      component: LoginErrorPage,
      meta: {
        displayHeader: false,
        analytics: "Error - Login error"
      }
    },
    {
      path: "/pages/:id",
      name: "content-page",
      component: ContentPage,
      meta: {
        title: "View Content Page",
        displayHeader: true
      }
    },
    {
      path: "/search-results/:query(.*)?",
      name: "search-results",
      component: SearchPage,
      meta: {
        title: "Search Page",
        displayHeader: true,
        hideSearch: true,
        showITAndHR: true
      }
    },
    {
      path: "/profile/:userName?/my-devices",
      name: "profile-page-devices",
      component: ProfilePage,
      meta: {
        title: "Profile Page",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/profile/:userName?/team-defaults",
      name: "profile-page-team",
      component: ProfilePage,
      meta: {
        title: "Profile Page",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/profile/:userName?/my-delegates",
      name: "profile-page-delegates",
      component: ProfilePage,
      meta: {
        title: "Profile Page",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/profile/:userName?",
      name: "profile-page",
      component: ProfilePage,
      meta: {
        title: "Profile Page",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/guided-help",
      redirect: to => {
        window.location.href = EMPLOYEE_HUB_URL + "/apps/guides/it-guide";
      }
    },

    {
      path: "/service-directory",
      name: "service-directory",
      component: ServiceDirectory,
      meta: {
        title: "IT Service Directory",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/service-directory/:id",
      name: "service-page",
      component: ServiceDirectory,
      meta: {
        title: "IT Service Directory",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/enterprise-service-directory",
      name: "enterprise-service-directory",
      redirect: '/enterprise-service-directory/ALL',
      component: EnterpriseServiceDirectory,
      meta: {
        title: "Enterprise Service Directory",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/enterprise-service-directory/:serviceDirectory/:id",
      name: "enterprise-service-page-direct",
      component: EnterpriseServiceDirectory,
      meta: {
        title: "Enterprise Service Directory",
        displayHeader: true,
        hideSearch: false,
        isDirectRequest: true
      }
    },
    {
      path: "/enterprise-service-directory/:serviceDirectory/:id",
      name: "enterprise-service-page-modal",
      component: EnterpriseServiceDirectory,
      meta: {
        title: "Enterprise Service Directory",
        displayHeader: true,
        hideSearch: false,
        isDirectRequest: false
      }
    },
    {
      path: "/enterprise-service-directory/:serviceDirectory",
      name: "enterprise-service-directory-page",
      component: EnterpriseServiceDirectory,
      meta: {
        title: "Enterprise Service Directory",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/:platformCategory/categories",
      name: "service-categories",
      component: BrowseService,
      meta: {
        title: "Service Category List",
        displayHeader: true,
        hideSearch: false
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/categories/:id",
      name: "service-categories-by-id",
      component: BrowseService,
      meta: {
        title: "Service Category",
        analytics: "Service Category By ID",
        displayHeader: true,
        hideSearch: false
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/services",
      name: "services",
      component: BrowseService,
      meta: {
        title: "Service List",
        displayHeader: true,
        hideSearch: false,
        showITAndHR: true
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/services/:serviceId",
      name: "services-by-id",
      component: BrowseService,
      meta: {
        title: "Service Page",
        displayHeader: true,
        hideSearch: false,
        showITAndHR: true
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/article-categories",
      name: "knowledge-articles",
      component: BrowseArticle,
      meta: {
        title: "Knowledge Articles",
        displayHeader: true,
        hideSearch: false
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/article-categories/:id",
      name: "knowledge-articles-by-id",
      component: BrowseArticle,
      meta: {
        title: "Knowledge Articles By ID",
        displayHeader: true,
        hideSearch: false
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/articles/:articleId",
      name: "knowledge-article",
      component: KnowledgeArticle,
      meta: {
        title: "Knowledge Article",
        displayHeader: true,
        hideSearch: false
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/:platformCategory/articles/:articleId/faq/:faqId",
      name: "knowledge-article-faqs",
      component: KnowledgeArticle,
      meta: {
        title: "Knowledge Article FAQs",
        displayHeader: true,
        hideSearch: false
      },
      beforeEnter: convertPlatformCategoryToUppercase
    },
    {
      path: "/support",
      name: "contact-support-page",
      component: ContactSupport,
      meta: {
        title: "Contact Support",
        displayHeader: true,
        hideSearch: false,
        showITAndHR: true
      }
    },
    {
      path: "/bookmarks",
      name: "bookmarks-page",
      component: AutodeskOneBookmarksPage,
      meta: {
        title: "Bookmarks",
        displayHeader: true,
        hideSearch: false
      }
    },
    {
      path: "/news",
      name: "news-feed-page",
      component: NewsFeedPage,
      meta: {
        title: "News",
        displayHeader: true,
        hideSearch: false,
      }
    },
    {
      path: "/news-by-interests",
      name: "news-by-interests-page",
      component: NewsFeedPage,
      meta: {
        title: "News by Interests",
        displayHeader: true,
        hideSearch: false,
        enableByInterests: true
      }
    },
    {
      path: "/news-summary",
      name: "news-summary",
      component: HomePage,
      meta: {
        displayHeader: true
      }
    },
    {
      path: "/events",
      name: "events",
      component: EventsPage,
      meta: {
        displayHeader: true
      }
    },
    {
      path: "*",
      name: "page not found",
      component: PageNotFound,
      meta: {
        analytics: "Error - Page not found",
        displayHeader: true,
        title: "Error - Page not found"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js